import {createSelector} from '@ngrx/store';

import {COUNTRIES_FEATURE_KEY, selectMasterDataModuleState} from '../reducers';

export const selectCountriesState = createSelector(
  selectMasterDataModuleState,
  (moduleState) => moduleState[COUNTRIES_FEATURE_KEY]
);

export const selectCountriesEntities = createSelector(
  selectCountriesState,
  (state) => state.entities
);

export const selectCountries = createSelector(
  selectCountriesEntities,
  (entities) => Object.values(entities)
);

export const selectErrors = createSelector(
  selectCountriesState,
  (state) => state.errors
);

export const isLoading = createSelector(
  selectCountriesState,
  (state) => state.loading
);

export const isLoaded = createSelector(
  selectCountriesState,
  (state) => state.loaded
);
